module.exports = __webpack_public_path__ + "img/sucmnke.93d8e7f3.png";